import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { dot, mix, normalWorld, step, texture, vec3 } from 'three/tsl';
import * as THREE from 'three/webgpu';

export const VEC3 = new THREE.Vector3();

export const IS_DEBUG_ENABLED = window.location.hash === '#debug';

const loader = new GLTFLoader();

export async function loadGLTFModel(url: string): Promise<THREE.Group> {
    return new Promise((resolve, reject) => {
        loader.load(
            url,
            (gltf) => {
                resolve(gltf.scene);
            },
            undefined,
            (error) => {
                reject(error);
            }
        );
    });
}

export function setToonMaterial(material: THREE.Material, mesh: THREE.Mesh) {
    const SHADOW_INTENSITY = 0.3;
    const LIGHT_DIR = vec3(-1, 1, -1).normalize();

    const source = material as THREE.MeshStandardMaterial;

    const diffuse = dot(normalWorld, LIGHT_DIR).clamp(0, 1);
    const toon = step(0.2, diffuse);

    const baseColor = source.map
        ? texture(source.map).rgb
        : vec3(source.color.r, source.color.g, source.color.b);

    const shadedColor = mix(baseColor.mul(SHADOW_INTENSITY), baseColor, toon);

    const toonMaterial = new THREE.MeshToonNodeMaterial();
    toonMaterial.name = source.name;
    toonMaterial.colorNode = shadedColor;

    if (Array.isArray(mesh.material)) {
        mesh.material = mesh.material.map((m) =>
            m === material ? toonMaterial : m
        );
    } else {
        mesh.material = toonMaterial;
    }
}
